import React from 'react';
import background from '../../assets/esa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoEsa extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Paris, France"
        description="ESA"
        paragraph="The European Space Agency is Europe’s gateway to space. Its mission is to shape the development of Europe’s space capability and ensure that investment in space continues to deliver benefits to the citizens of Europe and the world."
        background={background}
     />
  
  );
 }
}   

export default InfoEsa;